import {
  Drawer,
  PrimaryButton,
  Typography,
} from '@changegps/horizon-component-library';
import { Box } from '@mui/material';

interface XpmApiGuideProps {
  onClose: (runQuery?: boolean) => void;
  open: boolean;
}

export const XpmApiGuide = ({ onClose, open }: XpmApiGuideProps) => {
  const renderContent = () => {
    return (
      <Box>
        <Typography
          sx={{
            fontSize: '24px',
          }}
        >
          We have upgraded our XPM API system
        </Typography>
        <br />
        <p>You’ll need to upgrade to API v3 to keep your connection live.</p>
        <br />
        <p>
          We’re 100% committed to protecting the data and privacy of our
          partners and customers, and in uncertain times like these, that’s more
          important than ever.{' '}
        </p>
        <br />
        <p>
          To meet compliance rules that are being set out by tax offices around
          the world and to continue leading in best practice, we’re implementing
          new global security standards for digital services providers with
          add-on marketplaces.
        </p>
        <br />
        <Typography
          sx={{
            fontSize: '24px',
          }}
        >
          What you need to do
        </Typography>
        <br />
        <p>
          A new Staff Privilege has been added to control who has permission to
          connect your Account to 3rd Party Addons.
          <br />
          Any Staff with Administrator Privileges can assign this new Privilege
          to themselves or other Administrators.{' '}
        </p>
        <br />
        <p>
          Follow these steps for each Staff member you want to be able to
          authorise connections to 3rd Party Addons.
        </p>
        <br />
        <Box
          sx={{
            lineHeight: '1.7em',
          }}
        >
          <p>
            1. Go to the{' '}
            <a
              href="https://app.practicemanager.xero.com/admin/resourcelist.aspx"
              target="_blank"
              rel="noreferrer"
            >
              {'Business > Settings > Staff'}
            </a>{' '}
            page, or click on this link to go directly there.
          </p>
          <p>
            2. Search for the Staff Member that you would like to add this
            permission to.
          </p>
          <p>
            3. Ensure that the Staff has the Administrator Privilege. If they do
            not, tick the checkbox for this and Save the Staff settings first.
          </p>
          <p>
            4. You will now see a new Heading appear at the bottom of the page,
            “API Access Privileges”. Tick the checkbox for this and Save the
            Staff Settings to assign Authorise 3rd Party Full Access privilege.
          </p>
          <p>
            5. Go to ChangeGPS&apos;s settings page, Scroll down and open
            &quot;Connection Settings&quot; tab, and click &quot;Connect&quot;
            button
          </p>
          <br />
          <img src="https://i.imgur.com/nsngHLW.png" />
          <p>6. A small pop up window will come up. Login to Xero.</p>
          <img
            src="https://i.imgur.com/L87XdTJ.png"
            style={{ width: '300px' }}
          />
          <p>`${'7. Click "Allow access".'}`</p>
          <img
            src="https://i.imgur.com/HVD9Pwh.png"
            style={{ width: '300px' }}
          />

          <p> All done! Your XPM connection is now updated.</p>
        </Box>
      </Box>
    );
  };
  const handleClose = () => {
    onClose();
  };

  return (
    <Drawer
      sx={{
        width: '900px !important',
      }}
      title={<Typography></Typography>}
      onClose={handleClose}
      open={open}
      content={renderContent()}
      actions={
        <>
          <Box display={'flex'} gap={'8px'}>
            <PrimaryButton onClick={handleClose}>Close</PrimaryButton>
          </Box>
        </>
      }
    />
  );
};
